import { Grid2, IconButton } from '@mui/material';
import { Button } from '@mui/material';
import { Box } from '@mui/material';
import { VideoCard } from './VideoCard';
import { Video, VideoType } from '../types';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { VideoSearch } from './VideoSearch';
import { VideoTypeMenu } from './VideoTypeMenu';

interface VideoListProps {
  videos: Video[];
  isListVisible: boolean;
  toggleVideoList: () => void;
  loadMoreVideos: () => void;
  selectedVideoId: string | null;
  hasMoreVideos?: boolean;
  onVideoTypeChange: (videoType: VideoType) => void;
  videoType: VideoType;
  containerRef: React.RefObject<HTMLDivElement>;
  containerWidth: number;
  getGridSize: (width: number) => number;
  handleVideoClick: (videoId: string) => void;
  selectedVideoRef: React.RefObject<HTMLDivElement>;
  isMobile: boolean;
  onSearch: (value: string) => void;
  newVideoIds: Set<string>;
}

export const VideoList = ({
  videos,
  isListVisible,
  toggleVideoList,
  loadMoreVideos,
  selectedVideoId,
  hasMoreVideos,
  onVideoTypeChange,
  videoType,
  containerRef,
  containerWidth,
  getGridSize,
  handleVideoClick,
  selectedVideoRef,
  isMobile,
  onSearch,
  newVideoIds,
}: VideoListProps) => {
  return (
    <Box
      ref={containerRef}
      sx={{
        width: isListVisible ? (isMobile ? '100%' : '40%') : 'fit-content',
        minWidth: !isListVisible || isMobile ? '0' : '265px',
        borderRight: '1px solid rgba(255, 255, 255, 0.12)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 1,
          borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {isListVisible ? (
            <>
              <VideoSearch onSearch={onSearch} />
              <VideoTypeMenu videoType={videoType} onVideoTypeChange={onVideoTypeChange} />
            </>
          ) : null}
        </Box>
        <IconButton sx={{ marginLeft: 'auto' }} onClick={toggleVideoList}>
          {isListVisible ? <CloseIcon /> : <KeyboardArrowRightIcon />}
        </IconButton>
      </Box>

      {isListVisible && (
        <Box sx={{ overflow: 'auto', flex: 1, p: 2 }}>
          <Grid2 container spacing={2}>
            {videos.map(video => (
              <Grid2 size={{ xs: getGridSize(containerWidth) }} key={video.id} ref={video.id === selectedVideoId ? selectedVideoRef : null}>
                <VideoCard video={video} onClick={handleVideoClick} selected={video.id === selectedVideoId} isNew={newVideoIds.has(video.id)} />
              </Grid2>
            ))}
          </Grid2>
          {hasMoreVideos && (
            <Button sx={{ xs: 2, fontSize: '12px' }} variant="outlined" onClick={loadMoreVideos}>
              Load More
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};
